import * as React from "react"
import Link from "../components/link"
import WordpressContent from "../components/wordpress-content"
import MainLayout from "../layouts/main"

const NotFoundPage = (): JSX.Element => {
  const [loading, setLoading] = React.useState(true)
  React.useEffect(() => {
    // hacky workaround for case sensitive URLs
    if (typeof window !== `undefined`) {
      const { pathname } = window.location
      const lowerPathname = pathname.toLowerCase()
      if (pathname.includes(`/tab/`)) {
        window.location.href = lowerPathname.replace(`/tab/`, `/#tab/`)
      }
      if (lowerPathname !== pathname) {
        window.location.replace(lowerPathname)
      } else {
        setLoading(false)
      }
    }
  }, [])
  return (
    <MainLayout breadcrumbs={null} localMenuItem={null} minHeight={false}>
      {loading ? (
        <div>Hang tight we're looking for that page!</div>
      ) : (
        <WordpressContent
          html={`<div className="main-container border-none">
            <h1>404 not found</h1>
            <p>The page you are looking for cannot be found</p>
            <p>
              Lost? Start over at our <a href="/">home page</a>
            </p>
          </div>`}
        />
      )}
    </MainLayout>
  )
}

export const Head = (): JSX.Element => (
  <>
    <title id="page-title">404 Not Found | Georgian College</title>
  </>
)

export default NotFoundPage
